import React from 'react';
import { Modal as CModal } from 'antd';
import { mapModifiers } from '@/utils/funtion';
import Typography from '@/components/atoms/typography';

interface IModalProps {
  children?: React.ReactNode;
  open: boolean | undefined;
  textCancel?: string;
  textSubmit?: string;
  title?: string;
  template?: React.ReactNode | string;
  titleWithTemplate?: boolean;
  width?: number | string;
  confirmLoading?: boolean;
  centered?: boolean;
  maskClosable?: boolean;
  className?: string;
  zIndex?: number;
  onCancel?: () => void;
  onOk?: () => void;
  isHideSubmitBtn?: boolean;
  footer?: boolean;
  footerTemplate?: React.ReactNode;
  footerCustom?: boolean;
  closable?: boolean;
}

const Modal: React.FC<IModalProps> = ({
  open,
  children,
  footer,
  closable,
  width,
  onCancel,
  onOk,
  template,
  textCancel,
  title,
  textSubmit,
  confirmLoading,
  className,
  centered = false,
  maskClosable = true,
  zIndex = 10,
  isHideSubmitBtn = false,
  titleWithTemplate = false,
  footerCustom,
  footerTemplate,
}) => (
  <CModal
    open={open}
    centered={centered}
    maskClosable={maskClosable}
    confirmLoading={confirmLoading}
    className={mapModifiers(
      'o-modal',
      className,
      isHideSubmitBtn ? 'hide-submit-btn' : '',
    )}
    title={
      titleWithTemplate ? (
        template
      ) : (
        <div
          style={{
            height: 24,
          }}
        >
          <Typography type="h3" content={title} />
        </div>
      )
    }
    width={width}
    onCancel={onCancel}
    onOk={onOk}
    okText={textSubmit}
    cancelText={textCancel}
    zIndex={zIndex}
    footer={footerCustom ? footerTemplate : footer}
    closable={closable}
  >
    <div>{children}</div>
  </CModal>
);

export default Modal;
